/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { isNotNil } from '@gh/core-util';
import { Item, Layer, Point, Raster } from 'paper';
import { GraphicalTakeOffViewTransform } from '../../resources';
import {
  GraphicalTakeOffElementBase,
  paperEffect,
  PaperElementEffect,
} from './graphical-take-off-element';

const imagePaperEffects: PaperElementEffect[] = [
  paperEffect(
    'image',
    (item: Item, [image]: [HTMLImageElement], [previousImage]: [HTMLImageElement]) => {
      if (image !== previousImage) {
        item.removeChildren();
        item['$raster'] = void 0;

        if (isNotNil(image)) {
          const raster = new Raster({
            image,
            position: new Point(image.width / 2, image.height / 2),
            data: {
              id: 'raster',
            },
          });
          item.addChild(raster);
          item['$raster'] = raster;
        }
      }
    }),
];

@Component({
  standalone: false,
  selector: 'gh-graphical-take-off-canvas-image',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GraphicalTakeOffCanvasImageComponent extends GraphicalTakeOffElementBase {
  @Input() image: HTMLImageElement;
  @Input() viewTransform: GraphicalTakeOffViewTransform;

  constructor() {
    super(imagePaperEffects);
  }

  protected createPaperItem(): Item {
    const layer = new Layer({
      data: {
        id: 'rasterLayer',
        type: 'raster-layer',
      },
    });
    layer.sendToBack();
    return layer;
  }
}
